import { FormattedMessage, useIntl } from "react-intl";
import Account from "../../../utils/apiConfig";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import Textarea from "@mui/joy/Textarea";
import { Key, useEffect, useState } from "react";
import {
  Box,
  Button,
  Collapse,
  FormControlLabel,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import ApiServices from "../../../service/apiService";
import ErrorHandler from "../../../utils/errorConfig";
import {
  AuditHistoryViewDetails,
  AuditResponse,
} from "@mikros/library/src/model";
import { AudHistDet } from "@mikros/library";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Alert } from "@mikros/shared-ui";
import { useNavigate } from "react-router-dom";

export interface AuditHistoryProps {
  ref: any;
  employeeAuditHistDetails?: any;
  auditDialogToggle?: Function;
  auditDialogValue: boolean;
  dataGridItems?: any;
  userId: string;
  auditName: string;
}

export function AuditHistory(props: AuditHistoryProps) {
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();

  const intl = useIntl();
  const navigate = useNavigate();

  const [auditHistoryDetails, setAuditHistoryDetails] = useState<AudHistDet>({
    userDetails: {
      userId: "",
      username: "",
      auditName: "",
      department: "",
      location: "",
      branchName: "",
      designation: "",
    },
    auditHistory: [],
  });

  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  console.log(
    "audit history details print in audit history",
    auditHistoryDetails
  );
  console.log("audit name print", decodeURIComponent(props.auditName));
  console.log("audit name without decoding", props.auditName);
  console.log("audit history details", auditHistoryDetails);

  function convertToISTDate(utcTimestamp: string): string {
    const date = new Date(utcTimestamp);
    const istDate = new Date(date.getTime() + 5.5 * 60 * 60 * 1000);
    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      timeZone: "Asia/Kolkata",
    };
    return istDate.toLocaleDateString("en-GB", options).replace(/ /g, "-");
  }

  useEffect(() => {
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api
        .makeRequest(
          `${accountInstance.accntId}/useraudit/${props.userId}/history?auditName=${props.auditName}`,
          "GET"
        )
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log("Entered error code handling in audit history");
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            setAuditHistoryDetails(data);
          }
        });
      return;
    }
  }, [accountInstance.accntId]);

  console.log("selected user id", props.userId);
  console.log("audit name", props.auditName);

  const ratingOptions = [
    intl.formatMessage({ id: "audithistory.rating.excellent" }),
    intl.formatMessage({ id: "audithistory.rating.good" }),
    intl.formatMessage({ id: "audithistory.rating.average" }),
    intl.formatMessage({ id: "audithistory.rating.poor" }),
    intl.formatMessage({ id: "audithistory.rating.veryPoor" }),
  ];
  const getRatingLabel = (rating: number) => {
    // return ratingOptions[rating - 1]; //since array index starts from 0, subract 1
    return ratingOptions[ratingOptions.length - rating];
  };

  type UserDataType = (typeof auditHistoryDetails.auditHistory)[number];

  function CollapsibleRow(props: { row: UserDataType }) {
    const { row } = props;
    const [open, setOpen] = useState(false);
    return (
      <>
        <TableRow
          sx={{
            "& > *": {
              borderBottom: open ? "none" : "1px solid rgba(223,224,224,1)",
            },
            backgroundColor: open
              ? "transparent"
              : "var(--color-mk-primary-20)",

            // :"transparent",
            "&:hover": open
              ? {
                  backgroundColor: "#FFF !important", // Sets the background color to white on hover
                }
              : {},
          }}
        >
          <TableCell>
            <IconButton
              onClick={() => setOpen(!open)}
              aria-label="expand row"
              size="small"
              disableRipple
              disableFocusRipple
              style={{
                backgroundColor: "transparent", // Ensure no background color on hover
              }}
              sx={{
                "&:hover": {
                  backgroundColor: "transparent", // Prevent hover background color
                },
                "&:focus": {
                  backgroundColor: "transparent", // Prevent focus background color
                },
              }}
            >
              {open ? (
                <FontAwesomeIcon
                  icon={["fas", "fa-play" as IconName]}
                  className={`h-5 w-4.5 mx-3 hover:cursor-pointer text-mk-primary ${
                    open ? "rotate-90" : ""
                  }`}
                />
              ) : (
                <FontAwesomeIcon
                  icon={["fas", "fa-play" as IconName]}
                  className={`h-5 w-4.5 mx-3 hover:cursor-pointer text-mk-primary`}
                />
              )}
            </IconButton>
          </TableCell>
          <TableCell>{convertToISTDate(row.auditDate)}</TableCell>
          <TableCell>{row.auditedBy}</TableCell>
          <TableCell>{row.auditScore}</TableCell>
        </TableRow>
        <TableRow
          sx={{
            "& > *": {
              // borderBottom: open ? "20px solid #F5F6FD !important" : "none",
              borderBottom: open ? "20px solid #FFF !important" : "none",

              boxShadow: open ? "0px 4px 10px rgba(0,0,0,0.1)" : "none",
            },
            "&:hover": {
              backgroundColor: "#FFF !important", // Sets the background color to white on hover
            },
            marginBottom: open ? "16px" : "0",
            boxShadow: open ? "0px 4px 8px rgba(0, 0, 0, 0.1)" : "none", // Shadow effect when open
            padding: open ? "16px" : "0", // Optional padding inside the row when open
            borderRadius: open ? "8px" : "0", // Optional: rounded corners when ope
            zIndex: open ? 1 : "auto", // Brings the expanded row to the front
          }}
        >
          <TableCell colSpan={4} style={{ paddingBottom: 0, paddingTop: 0 }}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1} display="flex" alignItems="flex-start">
                <TableContainer
                  component={Paper}
                  elevation={0}
                  style={{ flex: 1 }}
                >
                  <Table
                    size="small"
                    aria-label="user details"
                    sx={{
                      "&:hover": {
                        backgroundColor: "#FFF !important", // Sets the background color to white on hover
                      },
                    }}
                  >
                    <TableHead
                      sx={{
                        backgroundColor: "#FFF",
                        // "&:hover": {
                        //   backgroundColor: "transparent !important",
                        // },

                        "& .MuiTableRow-root:hover": {
                          background: "var(--color-mk-white) !important",
                        },
                        "&:hover": {
                          backgroundColor: "var(--color-mk-white) !important",
                        },
                      }}
                    >
                      <TableRow
                        sx={{
                          "&:hover": {
                            backgroundColor: "#FFF !important", // Sets the background color to white on hover
                          },
                        }}
                      >
                        <TableCell>
                          <FormattedMessage id="audithistory.slNo" />
                        </TableCell>
                        <TableCell>
                          <FormattedMessage id="audithistory.checklist" />
                        </TableCell>

                        <TableCell colSpan={3}>
                          <strong>
                            <FormattedMessage id="audithistory.rating" />
                          </strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody
                      sx={{
                        "&:hover": {
                          backgroundColor: "#FFF !important", // Sets the background color to white on hover
                        },
                      }}
                    >
                      {row.auditResponse.map(
                        (detail: AuditResponse, index: number) => (
                          <TableRow
                            key={index}
                            sx={{
                              border: "none",
                              backgroundColor: "mk-white",
                              "&:hover": {
                                backgroundColor: "#FFF !important", // Sets the background color to white on hover
                              },
                            }}
                          >
                            <TableCell sx={{ border: "none" }}>
                              {/* {detail.slNo} */}
                              {index + 1}
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              {/* {detail.checklist} */}
                              {detail.Q}
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              <RadioGroup
                                row
                                value={getRatingLabel(
                                  // {detail.R} // {detail.rating}
                                  detail.R
                                )}
                              >
                                {ratingOptions.map((option) => (
                                  <FormControlLabel
                                    key={option}
                                    value={option}
                                    control={
                                      <Radio
                                        disableRipple //prevents ripple effect
                                        sx={{
                                          pointerEvents: "none", //disable interaction
                                          "&:hover": {
                                            backgroundColor: "transparent", //no hover effect
                                          },
                                          "&:focus": {
                                            backgroundColor: "transparent", //no focus effect
                                          },
                                          "&:.MuiSvgIcon-root": {
                                            cursor: "default !important", //keeps cursor normal
                                          },
                                        }}
                                      />
                                    }
                                    // label={option}
                                    label={
                                      <span style={{ fontSize: "0.875rem" }}>
                                        {option}
                                      </span>
                                    }
                                    sx={{
                                      cursor: "default !important", // Ensures default cursor on label
                                    }}
                                  />
                                ))}
                              </RadioGroup>
                            </TableCell>
                          </TableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                <Box
                  marginLeft={2}
                  display="flex"
                  flexDirection="column"
                  width={250}
                >
                  <Typography variant="subtitle1" gutterBottom>
                    <strong>
                      <FormattedMessage id="audithistory.essentialPoints" />
                    </strong>
                  </Typography>

                  <Textarea
                    minRows={row.auditResponse.length * 1.75}
                    maxRows={row.auditResponse.length * 1.75 + 2}
                    value={row.comments}
                    readOnly
                    sx={{
                      pointerEvents: "none",
                      cursor: "default !important",
                      backgroundColor: "var(--color-mk-white)",
                      border: "1px solid #E1E2E9",
                      "&:focus": {
                        outline: "none",
                      },
                      "&:hover": {
                        backgroundColor: "transparent", //no hover effect
                      },
                    }}
                  />
                </Box>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  }

  return (
    <div className="w-full">
      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              if (errorInstance.permDenied === true) {
                // navigate("/home");
                navigate("/home");
              } else {
                navigate("/audit");
              }
            }}
          />
        </Dialog>
      )}

      <div className="flex justify-between items-center mt-2">
        <div className="text-mk-primary-bright text-2xl font-extrabold ml-4">
          <FormattedMessage id="audithistory.auditHistory" />
        </div>
        <div
          onClick={() => {
            if (props.auditDialogToggle) {
              props.auditDialogToggle(!props.auditDialogValue);
            }
          }}
          className="pt-1 pb-1 pl-2 pr-2 rounded-full hover:cursor-pointer bg-mk-primary-50 mr-4"
        >
          <FontAwesomeIcon
            icon={["far", "fa-xmark" as IconName]}
            className="w-3 h-3"
          />
        </div>
      </div>

      <div className="mt-6"></div>
      <div className="grid grid-cols-3 gap-4 text-base items-center ml-4 mr-4">
        <div className="flex items-center space-x-2">
          <div className="font-bold w-36">
            <FormattedMessage id="users.auditView.employeeName" />:
          </div>
          <div className="gap-1">
            {auditHistoryDetails.userDetails.username}
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="font-bold w-36">
            <FormattedMessage id="audithistory.department" />:
          </div>
          <div className="gap-1">
            {auditHistoryDetails.userDetails.department}
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="font-bold w-36">
            <FormattedMessage id="audithistory.location" />:
          </div>
          <div className="gap-1">
            {auditHistoryDetails.userDetails.location}
          </div>
        </div>

        <div className="flex items-center space-x-2">
          <div className="font-bold w-36">
            <FormattedMessage id="audithistory.auditName" />:
          </div>
          <div className="gap-1">
            {auditHistoryDetails.userDetails.auditName}
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="font-bold w-36">
            <FormattedMessage id="audithistory.designation" />:
          </div>
          <div className="gap-1">
            {auditHistoryDetails.userDetails.designation}
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="font-bold w-36">
            <FormattedMessage id="audithistory.branch" />:
          </div>
          <div className="gap-1">
            {auditHistoryDetails.userDetails.branchName}
          </div>
        </div>
      </div>
      <div className="pb-[2%]"></div>

      <div style={{ marginRight: "1rem", marginLeft: "1rem" }}>
        <TableContainer component={Paper} elevation={0}>
          <Table size="medium" aria-label="collapsible table">
            <TableHead
              sx={{
                backgroundColor: "FFF !important",
                "& .MuiTableRow-root:hover": {
                  background: "var(--color-mk-white) !important",
                },
                "&:hover": {
                  backgroundColor: "var(--color-mk-white) !important",
                },
              }}
            >
              <TableRow
                sx={{
                  backgroundColor: "#FFF !important",
                  "&:hover": {
                    backgroundColor: "#FFF !important",
                  },
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                }}
              >
                <TableCell />
                <TableCell>
                  <FormattedMessage id="audithistory.auditedDate" />
                </TableCell>
                <TableCell>
                  <FormattedMessage id="audithistory.auditedBy" />
                </TableCell>
                <TableCell>
                  <FormattedMessage id="audithistory.auditScore" />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {auditHistoryDetails.auditHistory.map(
                (
                  row: AuditHistoryViewDetails,
                  index: Key | null | undefined
                ) => (
                  <CollapsibleRow key={index} row={row} />
                )
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <div className="mb-6"></div>

      <div className="flex justify-end">
        <Button
          type="submit"
          variant="contained"
          disableRipple
          sx={{
            mt: 2,
            marginRight: "1rem",
            borderRadius: "8px",
            textTransform: "capitalize",
            color: "white",

            backgroundColor: "#6464E5",
            "&:hover": {
              backgroundColor: "#E1E2E9",
              color: "black",
            },
            display: "inline-block",
          }}
          onClick={() => {
            if (props.auditDialogToggle) {
              props.auditDialogToggle(!props.auditDialogValue);
            }
          }}
        >
          <FormattedMessage id="closeButton"></FormattedMessage>
        </Button>
      </div>

      <div className="pb-[5%]"></div>
    </div>
  );
}
